<!--
  ~ QUEST SOFTWARE PROPRIETARY INFORMATION
  ~
  ~ This software is confidential.  Quest Software Inc., or one of its
  ~ subsidiaries, has supplied this software to you under terms of a
  ~ license agreement, nondisclosure agreement or both.
  ~
  ~ You may not copy, disclose, or use this software except in accordance with
  ~ those terms.
  ~
  ~
  ~ Copyright 2026 Quest Software Inc.
  ~ ALL RIGHTS RESERVED.
  ~
  ~ QUEST SOFTWARE INC. MAKES NO REPRESENTATIONS OR
  ~ WARRANTIES ABOUT THE SUITABILITY OF THE SOFTWARE,
  ~ EITHER EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED
  ~ TO THE IMPLIED WARRANTIES OF MERCHANTABILITY,
  ~ FITNESS FOR A PARTICULAR PURPOSE, OR
  ~ NON-INFRINGEMENT.  QUEST SOFTWARE SHALL NOT BE
  ~ LIABLE FOR ANY DAMAGES SUFFERED BY LICENSEE
  ~ AS A RESULT OF USING, MODIFYING OR DISTRIBUTING
  ~ THIS SOFTWARE OR ITS DERIVATIVES.
  -->

<fac-popup-dialog-header>
  <fac-popup-dialog-header-title [popupDialogHeaderTitle]="'Add to Bookmark'">
  </fac-popup-dialog-header-title>
</fac-popup-dialog-header>
<form [formGroup]="formGroup">
  <ng-container>
    <section>
      <fac-inputbox [label]="'Name*'" [appearance]="'outline'" formControlName="name"></fac-inputbox> 
      <div class="checkbox-comp">
        <fac-checkboxes
          [checked]="emailChecked"
          [size]="'medium'"
          (onInputValue)="sendEmailLink($event)"
        ></fac-checkboxes>
        <span [ngClass]="emailLink">Send an email with a link to this bookmark</span>
      </div>
    </section>
  </ng-container>
</form>
<fac-popup-dialog-footer [submitButtonText]="'Add'" [submitButtonDisabled]="formGroup.invalid" (submit)="onAddClick()"></fac-popup-dialog-footer>
